import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import PATHS from './routesMap'

import SignIn from '../views/auth/SignIn.vue'
import TipoUsuarioEnum from '../enums/tipoUsuarioEnum'

const routes = [
  {
    name: 'SignIn',
    path: PATHS.SIGN_IN,
    component: SignIn,
  },
  {
    name: 'MicrosoftCallBack',
    path: PATHS.MICROSOFT_CALLBACK,
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Callback.vue'),
    meta: {},
  },
  {
    name: 'PasswordRecovery',
    path: PATHS.PASSWORD_RECOVERY,
    component: () =>
      import(
        /* webpackChunkName: "auth" */ '../views/auth/PasswordRecovery.vue'
      ),
  },
  {
    name: 'NewPassword',
    path: PATHS.NEW_PASSWORD,
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/NewPassword.vue'),
  },
  {
    name: 'Home',
    path: PATHS.HOME,
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'EthosCompanies',
    path: PATHS.ETHOS_COMPANIES,
    component: () =>
      import(/* webpackChunkName: "ethos" */ '../views/ethos/Companies.vue'),
    meta: {
      requiresAuth: true,
      requiresEthos: true,
    },
  },
  {
    name: 'EthosReports',
    path: PATHS.ETHOS_REPORTS,
    component: () =>
      import(/* webpackChunkName: "ethos" */ '../views/ethos/Reports.vue'),
    meta: {
      requiresAuth: true,
      requiresEthos: true,
    },
  },
  {
    name: 'SyncData',
    path: PATHS.SYNC_DATA,
    component: () =>
      import(/* webpackChunkName: "company" */ '../views/company/SyncData.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'Users',
    path: PATHS.USERS,
    component: () =>
      import(/* webpackChunkName: "company" */ '../views/company/Users.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'Profiles',
    path: PATHS.PROFILES,
    component: () =>
      import(/* webpackChunkName: "company" */ '../views/company/Profiles.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'Report',
    path: PATHS.REPORT,
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/company/Report.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Unauthorized',
    path: PATHS.UNAUTHORIZED,
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from) => {
  const { user, isLoggedInEthosReports } = store.getters

  if (isLoggedInEthosReports && to.name === 'SignIn') {
    return { name: 'Home' }
  }

  if (to.meta.requiresAuth) {
    if (!isLoggedInEthosReports && !localStorage.getItem('tokenEthosReports')) {
      return { name: 'SignIn' }
    }

    if (to.meta.requiresAdmin && Number(user.tipo) !== TipoUsuarioEnum.ADMIN) {
      return { name: 'Unauthorized' }
    }

    if (to.meta.requiresEthos && Number(user.tipo) !== TipoUsuarioEnum.ETHOS) {
      return { name: 'Unauthorized' }
    }
  }
})

router.afterEach(async (to, from) => {
  if (!store.getters.isLoggedInEthosReports && to.meta.requiresAuth) {
    await store.dispatch('logout')
    router.push(PATHS.SIGN_IN)
  }
})

export default router
